module.exports = __webpack_public_path__ + "img/fb08.7cd561e1.jpg";